export default __webpack_public_path__ + "static/media/ic-instruction-15.387994a2.svg";